import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.3269 6.61539H11.9646C11.8428 6.61624 11.7231 6.58301 11.6191 6.51947C11.5151 6.45593 11.431 6.3646 11.3762 6.25577L10.7942 5.08539C10.6311 4.7587 10.3801 4.48401 10.0694 4.29226C9.75861 4.1005 9.40052 3.99929 9.03538 4H4.28846C3.68152 4 3.09944 4.24111 2.67027 4.67028C2.2411 5.09945 2 5.68153 2 6.28846V18.7115C2 19.3185 2.2411 19.9006 2.67027 20.3297C3.09944 20.7589 3.68152 21 4.28846 21H19.3269C19.9339 21 20.5159 20.7589 20.9451 20.3297C21.3743 19.9006 21.6154 19.3185 21.6154 18.7115V8.90385C21.6154 8.29691 21.3743 7.71483 20.9451 7.28566C20.5159 6.85649 19.9339 6.61539 19.3269 6.61539Z"
      fill="#C2C2C2"
    />
    <path
      d="M2.67027 20.3296C2.2411 19.9004 2 19.3184 2 18.7114V10H21.6154V18.7114C21.6154 19.3184 21.3743 19.9004 20.9451 20.3296C20.5159 20.7588 19.9339 20.9999 19.3269 20.9999H4.28846C3.68152 20.9999 3.09944 20.7588 2.67027 20.3296Z"
      fill="#333333"
    />
  </svg>
);

const FolderBackIcon = (props) => <Icon component={svg} {...props} />;

export default FolderBackIcon;
